<template>
    <div :class="mobile ? '' : 'foxy-panel p-5'">
        <h3 v-if="!mobile" class="mb-1 flex items-center gap-2 text-lg font-bold text-foxy-text">
            <i class="fas fa-filter text-sm text-foxy-action" aria-hidden="true"></i>
            Фільтри
        </h3>

        <div :class="!mobile && createDiscussionUrl ? 'mb-7' : ''">
            <span class="mb-4 block text-xs font-semibold uppercase tracking-wide text-foxy-text-secondary">
                Тип допису
            </span>
            <div class="space-y-1.5" role="group" aria-label="Тип допису">
                <button
                    v-for="filter in filters"
                    :key="filter.value"
                    type="button"
                    :aria-pressed="activeFilter === filter.value ? 'true' : 'false'"
                    :data-feed-filter-active="activeFilter === filter.value ? 'true' : null"
                    data-feed-filter
                    @click="setFilter(filter.value)"
                    :class="[
                        'group flex min-h-11 w-full min-w-0 items-center gap-3 rounded-lg px-3 py-2 text-left text-sm transition-colors',
                        'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-foxy-action/20',
                        activeFilter === filter.value
                            ? 'bg-foxy-action/10 font-bold text-foxy-action ring-1 ring-inset ring-foxy-action/20'
                            : 'font-medium text-foxy-text-secondary hover:bg-foxy-elevated/70 hover:text-foxy-text'
                    ]"
                >
                    <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors"
                        :class="activeFilter === filter.value
                            ? 'bg-foxy-action/15 text-foxy-action'
                            : 'bg-foxy-elevated/70 text-foxy-text-secondary group-hover:text-foxy-text'"
                        aria-hidden="true">
                        <i :class="filter.icon"></i>
                    </span>
                    <span class="min-w-0 flex-1 leading-snug">{{ filter.label }}</span>
                </button>
            </div>
        </div>

        <div v-if="!mobile && createDiscussionUrl"
            class="mb-3 border-t border-foxy-border pt-4"
            data-feed-discussion-action>
            <a :href="createDiscussionUrl" class="foxy-btn-secondary w-full px-4 py-3">
                <i class="fas fa-plus-circle" aria-hidden="true"></i>
                Розпочати дискусію
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContentFilters',
    props: {
        activeFilter: {
            type: String,
            default: 'all',
        },
        mobile: {
            type: Boolean,
            default: false,
        },
        createDiscussionUrl: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            filters: [
                { value: 'all', label: 'Усі дописи', icon: 'fas fa-stream' },
                { value: 'discussion', label: 'Дискусії', icon: 'fas fa-comments' },
                { value: 'review', label: 'Рецензії та відгуки', icon: 'fas fa-star' },
                { value: 'quote', label: 'Цитати', icon: 'fas fa-quote-right' },
                { value: 'fact', label: 'Факти', icon: 'fas fa-lightbulb' },
                { value: 'collection', label: 'Добірки', icon: 'fas fa-layer-group' },
            ],
        };
    },
    methods: {
        setFilter(filterValue) {
            if (filterValue !== this.activeFilter) {
                this.$emit('filter-changed', filterValue);
            }
        },
    },
};
</script>
